// ** Initial State
const initialState = {
  allData: [],
  data: null,
  cancelled_user_data:null,
  cancelledUsersDataWithPagination: {
    limit: 30,
    page: 0,
    total_pages: null,
    total_records: null,
    data: null,
  },
  pageLoader: true,
};

const cancelledUsers = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_CANCELLED_USERS_WITH_PAGINATION":
      return {
        ...state,
        cancelledUsersDataWithPagination: action.data,
        pageLoader: false,
      };
    case "GET_CANCELLED_USER_DATA":
      return {
        ...state,cancelled_user_data: action.data?.data,
      };
    case "PAGE_LOADER":
      return { ...state, pageLoader: action.data };
    default:
      return { ...state };
  }
};
export default cancelledUsers;
